import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { LoadMode, LoadModeHelper } from '../../enums';
import { formatBatteryRanges } from '../../models/battery-range.model';
import { loadModeToLabel } from '../../models/battery-sizing.model';
import {
  blocVoltageToNumber,
  computeTwoVoltBlocks,
  SizingTool,
} from '../../models/sizing-tool.model';

@Component({
  selector: 'app-sizing-tool-summary',
  standalone: true,
  imports: [NzIconModule, NzTypographyModule, RouterLink],
  templateUrl: './sizing-tool-summary.component.html',
  styleUrl: './sizing-tool-summary.component.scss',
})
export class SizingToolSummaryComponent {
  readonly sizingTool = input.required<SizingTool>();

  // Derived values used in template
  readonly blocVoltageNumber = computed(() =>
    blocVoltageToNumber(this.sizingTool().blocVoltage),
  );
  readonly twoVoltBlocks = computed(() =>
    computeTwoVoltBlocks(
      this.sizingTool().nbBlocks,
      this.sizingTool().blocVoltage,
    ),
  );
  readonly loadModeLabel = computed(() =>
    loadModeToLabel(this.sizingTool().sizingMode),
  );
  readonly batteryRangesText = computed(() =>
    formatBatteryRanges(this.sizingTool().batteryRanges),
  );
  readonly loadUnit = computed(() =>
    LoadModeHelper.getUnit(this.sizingTool()?.sizingMode ?? LoadMode.WATTS),
  );
}
